import hasImageUploadCare from './hasImageUploadCare';

/**
 * getQualityInSrc
 * @param src source image
 * @returns quality
 */
export default (src: string): string => {
  //nếu source lỗi hoặc k phải upload care thì trả về quality rỗng
  let resultQuality = '';
  if (!src || !hasImageUploadCare(src)) {
    return '';
  }

  //kiểm tra xem có quality trước đó không nếu k có quality thì không làm gì cả vì uploadcare có vài trường hợp sẽ k có quality
  const operations = src.split('-/');
  if (operations && operations.length) {
    operations.forEach((item, index) => {
      if (!item) return;
      const kvArr = item.split('/'); //chia ra key/value bằng dấu /
      if (kvArr && kvArr[0] && kvArr[1] && kvArr[0] == 'quality') {
        resultQuality = kvArr[1];
      }
    });
  }

  return resultQuality;
};
